export default __webpack_public_path__ + "static/media/WRadio.d984740f.jpg";